package com.anjuros.website.redesign.sections.trades

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdBreadcrumb
import com.anjuros.website.redesign.components.RdLede
import com.anjuros.website.redesign.components.RdPrimaryButton
import com.anjuros.website.redesign.components.rdScrollToAfterRender
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.RdSubpageTitleStyle
import com.anjuros.website.redesign.styles.TradesFinderLabelStyle
import com.anjuros.website.redesign.styles.TradesFinderStyle
import com.anjuros.website.redesign.styles.TradesHeroStackStyle
import com.anjuros.website.redesign.styles.TradesHeroStyle
import com.anjuros.website.redesign.styles.TradesHeroTitleStyle
import com.anjuros.website.redesign.styles.TradesSearchButtonStyle
import com.anjuros.website.redesign.styles.TradesSearchStyle
import com.anjuros.website.redesign.styles.TradesSectorsStyle
import com.anjuros.website.redesign.styles.TradesTitleAccentStyle
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** Dark hero with a "find your trade" search that filters the directory below. */
@Composable
fun TradesHeroSection(query: String, onQueryChange: (String) -> Unit) {
    RdSection(labelledBy = "h1", modifier = TradesHeroStyle.toModifier(), wrapModifier = TradesHeroStackStyle.toModifier()) {
        RdBreadcrumb(RdText.TRADES_CRUMB)
        H1(RdSubpageTitleStyle.toModifier().then(TradesHeroTitleStyle.toModifier()).id("h1").toAttrs()) {
            Text(LocalText(RdText.TRADES_HERO_TITLE_START))
            Span(TradesTitleAccentStyle.toModifier().toAttrs()) { Text(LocalText(RdText.TRADES_HERO_TITLE_MARK)) }
        }
        RdLede(RdText.TRADES_HERO_LEDE)
        Div(TradesFinderStyle.toModifier().toAttrs()) {
            Label(forId = "trade-search", attrs = TradesFinderLabelStyle.toModifier().toAttrs()) {
                Text(LocalText(RdText.TRADES_FIND_LABEL))
            }
            SearchBox(query, onQueryChange)
            SectorLinks(onQueryChange)
        }
    }
}

@Composable
private fun SearchBox(query: String, onQueryChange: (String) -> Unit) {
    val placeholder = LocalText(RdText.TRADES_FIND_PLACEHOLDER)
    Div(TradesSearchStyle.toModifier().toAttrs()) {
        RdIcons.Search(size = 22)
        Input(InputType.Search) {
            id("trade-search")
            placeholder(placeholder)
            attr("autocomplete", "off")
            value(query)
            onInput { onQueryChange(it.value) }
        }
        Div(TradesSearchButtonStyle.toModifier().toAttrs()) {
            RdPrimaryButton(RdRoute.CONTACT, RdText.CTA_FREE_PREVIEW)
        }
    }
}

@Composable
private fun SectorLinks(onQueryChange: (String) -> Unit) {
    val label = LocalText(RdText.TRADES_SECTORS_LABEL)
    Nav(TradesSectorsStyle.toModifier().attrsModifier { attr("aria-label", label) }.toAttrs()) {
        TradeGroups.forEach { group ->
            // Clear the search first, otherwise the target group may be hidden by the filter.
            A("#${group.id}", attrs = {
                onClick {
                    it.preventDefault()
                    onQueryChange("")
                    rdScrollToAfterRender(group.id)
                }
            }) { Text(LocalText(group.sector)) }
        }
    }
}
